__turbopack_context__.v({
  "className": "bebas_neue_30afa7f3-module__WNoKJW__className",
});
